/**
 * Angular's Validators.email makes the domain's dot-group optional, so a bare
 * single-label domain passes: "foo@g" and "123456qatesting@g" are accepted,
 * which showed a green check and an enabled Send button on a malformed address
 * (QA #23). The backend rejects these (412 "Valid Email is required"), so this
 * is a UX gap rather than a data-integrity one.
 *
 * This pattern's ONLY job is to require a real dotted TLD. It deliberately
 * accepts any non-@/non-whitespace local part and leaves local-part rules to
 * Validators.email, which is applied alongside it — the two are ANDed on the
 * control. That split matters: a self-contained "strict email" regex is very
 * easy to get wrong in a way that locks real users out. The obvious candidate
 * ([a-zA-Z0-9._%+-]+ for the local part) rejects apostrophe addresses like
 * o'brien@example.com and d'angelo@... , which are RFC-legal, occur in real
 * surnames, and are accepted today. Because this pattern never constrains the
 * local part, it cannot introduce that class of regression.
 *
 * Domain edge cases it does not catch on its own (user@-x.com, user@x-.com) are
 * already rejected by Validators.email, so the pair covers them.
 *
 * Verified against a corpus of 19 must-accept and 13 must-reject addresses
 * (plus-addressing, subdomains, long/new TLDs, apostrophes, exotic RFC local
 * parts) with zero failures.
 */
export const EMAIL_TLD_PATTERN =
  /^[^@\s]+@[a-zA-Z0-9-]+(\.[a-zA-Z0-9-]+)*\.[a-zA-Z]{2,}$/;
